import {
    ApiActivationRequest,
    ApiCompoundAccess,
    ApiFeatureActivationStatus,
    ApiFeatures,
    ApiSupplier,
    ApiTermsAndConditionsAgreement,
} from '../types/activationsApi.types';
import {
    CompoundAccess,
    FeatureActivations,
    FeatureActivationStatus,
    Supplier,
    TermsAndConditionsAgreement,
} from '../../activation/activation.types';
import { RegistrationInputs } from '../../activation/registration.types';
import { NonEmptyString } from 'io-ts-types';

export const mapTermsAndConditionsAgreement = (
    apiTermsAndConditionsAgreement: ApiTermsAndConditionsAgreement,
): TermsAndConditionsAgreement => {
    return { accepted: apiTermsAndConditionsAgreement.accepted };
};

const mapToFeatureActivationStatus = (status: ApiFeatureActivationStatus): FeatureActivationStatus => {
    switch (status) {
        case ApiFeatureActivationStatus.APPROVED:
            return FeatureActivationStatus.APPROVED;
        case ApiFeatureActivationStatus.PENDING:
            return FeatureActivationStatus.PENDING;
        case ApiFeatureActivationStatus.NONE:
            return FeatureActivationStatus.NONE;
    }
};

const mapToCompoundFeatureAccess = (access: ApiCompoundAccess): CompoundAccess => {
    switch (access) {
        case ApiCompoundAccess.ACCESS:
            return CompoundAccess.ACCESS;
        case ApiCompoundAccess.NO_ACCESS:
            return CompoundAccess.NO_ACCESS;
    }
};

export const mapToSupplier = (apiSupplier: ApiSupplier): Supplier => {
    switch (apiSupplier) {
        case ApiSupplier.VW:
            return Supplier.VW;
        case ApiSupplier.RIO_INTERNAL:
            return Supplier.RIO_INTERNAL;
        case ApiSupplier.RIO_MONITORING:
            return Supplier.RIO_MONITORING;
    }
};

export const mapToFeatureActivations = (features: ApiFeatures): FeatureActivations => ({
    activationStatus: mapToFeatureActivationStatus(features.activation_status),
    compound: mapToCompoundFeatureAccess(features.compound),
});

export const mapToApiActivationRequest = (registrationInputs: RegistrationInputs): ApiActivationRequest => ({
    supplier: ApiSupplier.VW,
    service_provider_identification: registrationInputs.serviceProviderIdentification as NonEmptyString,
    duns: registrationInputs.duns as NonEmptyString,
    interface_access_requested: registrationInputs.interfaceAccessRequested === 'interface',
    ...(registrationInputs.phone.length !== 0 && { phone: registrationInputs.phone as NonEmptyString }),
});
